<template>
  <div>
    <ModalHomologa v-if="modalHomologacao">
      <div class="modal-header">
        <h3><strong>N° RRIM:</strong> {{ dados.InforGeral.IGRRIM }}</h3>
        <h3><strong>Molde:</strong> {{ dados.InforGeral.IGMolde }}</h3>
        <h3><strong>Cliente:</strong> {{ dados.InforGeral.IGCliente }}</h3>
      </div>

      <div class="modal-comentario">
        <span><strong>Comentario:</strong></span>
        <textarea style="width: 100%;resize: none" class="textarea_hom" v-model="ComentarioHomolgacao" rows="7" >
        </textarea>
      </div>

      <div class="modal-buttons">
        <button class="btn1 aprovar" @click="showModalConfirmacao(true)">
          Aprovar
        </button>
        <button class="btn1 reprovar" @click="showModalConfirmacao(false)">
          Reprovar
        </button>
        <button class="btn1 cancelar" @click="fecharModalHomolacao">
          Cancelar
        </button>


      </div>

      <div class="modal-confirmacao" v-if="showConfirmacao">
        <span v-if="statusHomologacao">Sim, eu desejo confirmar a <strong style="color: var(--green);">APROVAÇÃO</strong> desta
          RRIM</span>
        <span v-if="!statusHomologacao">Sim, eu desejo confirmar a <strong style="color: var(--red);">REPROVACAO</strong> desta
          RRIM</span>
        <div class="confirmacao-buttons">
          <button class="btn-modal" @click="homologar(statusHomologacao, dados.InforGeral.IGRRIM)">
            Sim, confirmar
          </button>
        </div>
      </div>
    </ModalHomologa>
    <transition name="model">
      <form @submit.prevent="submitForm">
        <div class="modal_mask">
          <div class="blurringbackground" :class = "{'show': vmodal}">
          </div>
          <div class="modal_content">
            <div class="modal_header">
              <div class="title_modal">
                <div class="flex">
                  <h4>Visualizar RRIM</h4>
                  <button @click="finish_modal" class="close_button">
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-body">
              <div class="card-header">
                <ul>
                  <li>
                    <a :class="[active_rrim, 'nav-link']" @click="click_rrim">RRIM</a>
                  </li>
                  <li>
                    <a :class="[active_fotos, 'nav-link']" @click="click_fotos">Fotos</a>
                  </li>
                  <li>
                    <a :class="[active_lsp, 'nav-link']" @click="click_lsp">LSP</a>
                  </li>
                </ul>
              </div>

              <div class="tab-content">
                <div v-show="rrim">
                  <RRIM :configInputs="1" @setObjOfInforGeral="getObjOfInforGeral" @setListPro="getListPro"
                    @setObjMoldeFechado="getObjMoldeFechado" @setObjMoldeAberto="getObjMoldeAberto" />
                </div>

                <div v-show="fotos" class="fotos">
                  <FOTOS :configInputs="1" @SendDataImages="getObjAllImages" />
                </div>

                <div v-show="lsp">
                  <LSP :configInputs="1" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button v-if="homologation && role === 'eng_admin'" class="btn btn-blue" @click="openModalHomologation">
                Homologar
              </button>
              <button type="button" class="btn" @click="Modalcancelar" data-dismiss="modal">
                Fechar
              </button>
              <button if="dados." type="button" class="btn" @click="exportar"
                data-dismiss="modal">
                Exportar
              </button>
            </div>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>


<script>
import RRIM from "./Modules/RRIM/LayoutView.vue";
import FOTOS from "./Modules/FOTOSRRIM/LayoutView.vue";
import LSP from "./Modules/LSP/LayoutView.vue";
import useVuelidate from "@vuelidate/core";
import ModalHomologa from "@/components/Modais/ModalHomologa.vue";
import { api } from "../../../http/index";
import { store } from "../../../store/store";

// import { required, minLength } from '@vuelidate/validators'

export default {
  components: {
    RRIM,
    FOTOS,
    LSP,
    ModalHomologa
  },
  props: {
    homologation: {
      type: Boolean,
      required: false
    },
    role: {
      type: String,
      required: false
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      statusHomologacao: false,
      modalHomologacao: false,
      showConfirmacao: false,
      ComentarioHomolgacao: '',
      active_rrim: "active-tab",
      active_fotos: "",
      active_lsp: "",
      vmodal: true,
      rrim: true,
      fotos: false,
      lsp: false,
      teste2: undefined,

      dados: {
        InforGeral: Object,
        Produtos: Object,
        Molde_Fechado: Object,
        Molde_Aberto: Object,
      },
      dadosImages: Object,
    };
  },
  mounted() {
    document.body.classList.add('sc');
  },
  beforeUnmount() {
    document.body.classList.remove('sc');
  },
  methods: {
    async exportar() {
      const data = await this.$store.getters.$GetDataAllRRIM;
      const toast = await this.$swal
        .fire({
          title: "Deseja exportar RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      const exportDocument = this.$router.resolve({
        path: "/export",
        query: { id: data.InforGeral.ID },
      });

      window.open(exportDocument.href, "_blank");

      this.$store.commit("MutationSetCancelModalViewRRIM", true);
    },

    showModalConfirmacao(valorConfirmacao) {
      this.statusHomologacao = valorConfirmacao;
      this.showConfirmacao = true;
    },

    openModalHomologation() {
      this.modalHomologacao = true
      document.body.classList.add('modal-open');
    },

    fecharModalHomolacao() {
      this.modalHomologacao = false
      document.body.classList.remove('modal-open');
    },

    async homologar(valorConfirmacao, rrim) {
      const match = rrim.match(/\d+/)
      let newRrim = Number(match[0])

      const Toast = await this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (
        this.ComentarioHomolgacao === ''
      ) {
        Toast.fire({
          icon: "success",
          title: "Você deve adicionar um comentário!",
        });
      }

      if (valorConfirmacao) {
        await api
          .put(`/rrim/homologation/${newRrim}`, {
            status: 2,
            comentario: this.ComentarioHomolgacao,
          })
          .then((res) => {
            Toast.fire({
              icon: "success",
              title: "RRIM Aprovada!",
            });
          });
      } else {
        await api
          .put(`/rrim/homologation/${newRrim}`, {
            status: 3,
            comentario: this.ComentarioHomolgacao,
          })
          .then((res) => {
            Toast.fire({
              icon: "success",
              title: "RRIM Reprovada!",
            });
          });
      }
      window.location.reload();
    },

    async Modalcancelar() {
      this.$store.commit("MutationSetCancelModalViewRRIM", false);
    },
    click_rrim() {
      this.rrim = true;
      this.fotos = false;
      this.lsp = false;
      this.active_rrim = "active-tab";
      this.active_fotos = "";
      this.active_lsp = "";
    },

    click_fotos() {
      this.rrim = false;
      this.fotos = true;
      this.lsp = false;
      this.active_rrim = "";
      this.active_fotos = "active-tab";
      this.active_lsp = "";
    },

    click_lsp() {
      this.rrim = false;
      this.fotos = false;
      this.lsp = true;
      this.active_rrim = "";
      this.active_fotos = "";
      this.active_lsp = "active-tab";
    },

    finish_modal() {
      this.$store.commit("MutationSetCancelModalViewRRIM", false);
      this.vmodal = !this.vmodal;
    },

    getObjOfInforGeral(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.InforGeral = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getListPro(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.Produtos = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getObjAllImages(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dadosImages = val;
      this.teste2 = this.dadosImages;
      this.$store.commit("SetLoadingPattern", false);
    },

    getObjMoldeFechado(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.Molde_Fechado = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getObjMoldeAberto(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.Molde_Aberto = val;
      this.$store.commit("SetLoadingPattern", false);
    },
  },
};
</script>


<style scoped>


h4 {
  color: var(--font_color);
  font-family: 'Poppins', sans-serif!important;
  font-weight: 600!important;
  font-size: 1.7rem;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: white;
  padding: 20px;
  border-radius: 10px;
}

.blurringbackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(3px); 
  transition: opacity 0.3s ease, visibility 0.3s ease;
  visibility: hidden;
  opacity: 0;
  }

  
.blurringbackground.show {
    visibility: visible;
    opacity: 1;
  }

.close_button{
  background-image: url("../../../static/icons/close_iconblack.svg");
  background-repeat: no-repeat;
  background-size: 70%;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem; 
  background-color: rgba(255, 0, 0, 0);
  border-radius: 50%; 
  display: inline-block; 
  transition: background-color 0.3s ease; 
  transition: outline 0.3s ease; 
}

.close_button:hover{
  background-color: var(--gray);
  outline: 6px solid var(--gray);
}

.modal_mask {
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}

.modal-confirmacao {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

@keyframes growIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1); 
  }
}

@keyframes growOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
}

.modal_mask .modal_content {
  position: relative;
  width: 80%;
  margin: 8vh auto;
  background: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  box-shadow: 4px 4px 5px rgba(75, 74, 74, 0.5); 
  animation: growIn 0.15s ease-out forwards; 
}

.modal_header{
  width: 100%;
  padding: 1rem 2.3rem 0rem;
}

.title_modal {
  display: flex;
  align-items: center;
  width: 100%;
}

.flex {
  display: flex!important;
  flex-direction: row!important;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0rem;
}

.card-header {
  padding: 0.5rem 3rem;
}

.card-header ul{
  display: flex;
  gap: 2rem;
  list-style-type: none;
  justify-content: center;
}


.card-header ul li{
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 0.5rem;
  cursor: pointer;
  width: 5rem;
  border: 2px solid var(--font_color);
}

.card-header ul li:active{
  color: white!important;
  background-color: var(--font_color);
}

.card-header ul li a{
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--font_color);
  font-weight: 500;
  font-family: 'Poppins', sans-serif!important;
  width: 10.5rem;
  height: 2.8rem;
}

.card-header ul li a:hover{
  font-weight: 800;
}

.card-header ul li a:checked{
   color: white !important;
}

.card-header ul li a:active{
   color: white !important;
}

.active-tab {
  background-color: var(--font_color); 
  color: white !important;    
}

.tab-content {
}

.modal-footer {
  display: flex;
  padding: 1rem 0.5rem;
  gap: 0.5rem;
  width: 100%;
  flex-direction: row-reverse;
}

.btn {
  color: var(--font_color);
  font-weight: 800;
  transition: all 0.3s ease;
}

.btn:hover{
  color: black;
  font-weight: 800;
  background-color: var(--font_color);
  color: white;
}

.btn1 {
  border: 2px solid;
  background-color: white;
  color: var(--font_color);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn1.aprovar {
  border-color: var(--green);
  color: var(--green);
}

.btn1.aprovar:hover {
  background-color: var(--green);
  color: white;
}

.btn1.reprovar {
  border-color: var(--red);
  color: var(--red);
}

.btn1.reprovar:hover {
  background-color: var(--red);
  color: white;
}

.btn1.cancelar {
  border-color: orange;
  color: orange;
}

.btn1.cancelar:hover {
  background-color: orange;
  color: white;
}

.modal-header {
  padding: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}

.modal-comentario {
  padding: 1rem;
}

.modal-buttons {
  display: flex;
  padding: 1rem 0.5rem;
  gap: 0.5rem;
  width: 100%;
  flex-direction: row-reverse;
}

.textarea_hom {
  width: 100%!important;
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  padding: 0.5rem;
  color: var(--font_color);
}

.textarea_hom:hover {
  border: 1.5px solid var(--green);
  color: green;
}

.btn-modal {
  border: 2px solid;
  border-color: var(--font_color);
  color: var(--font_color);
  background-color: white;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}


.btn-modal:hover {
  background-color: var(--font_color);
  color: white;
}

@media (max-width: 1526px) {
  .modal_mask .modal_content {
    width: 95%!important;
    
  }
}
@media (max-width: 450px) {
  .modal_mask .modal_content {
    width: 95%!important;
    
  }
}

</style>
